module.exports = __webpack_public_path__ + "static/25years-d74d5390f8392d375ec897300cb5850e.png";